import styled from 'styled-components';

export const Container = styled.div`
    display:flex;
    flex-direction: column;
    height:100%;
    width:100%;
    padding: 15px;
    text-align: center;
`;

export const TodosAlimentos = styled.div`
    display:flex;
    height:calc(100% - 130px);
    @media (max-width: 768px) {
        flex-direction: column;
        height: calc(100% - 130px);
    }


`;

export const ContainerListaAlimentos = styled.div`
    display:flex;
    flex-direction: column;
    width:100%;
    overflow-y:auto;
    padding: 0px 10px;
   
    @media (max-width: 768px) {
        height: 50%;
    }
`;

export const Alimento = styled.div`
    display:flex;
    width:100%;
    margin: 5px 0px;
    padding: 5px;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    flex: auto 1 0;
    :hover{
        background-color:#dedede;
    }
`;

export const BtnSelecionar = styled.div`
    padding: 5px 10px;
    border-radius: 5px;
    color:#fff;
    background-color: var(--primaryColor);
    cursor: pointer;
    height: 27px;
    transition-duration: .5s;

    :hover{
        background-color: var(--primaryColorHover);
    };

    :active{
        transform: scale(.9)
    };
`;

export const BtnRemover = styled.div`
    padding: 5px 10px;
    border-radius: 5px;
    color:#fff;
    background-color: var(--cancelColor);
    cursor: pointer;
    height: 27px;
    transition-duration: .2s;

    :hover{
        background-color: var(--cancelColorHover);
    };

    :active{
        transform: scale(.9)
    };
`;

export const InputBusca = styled.input`
    background-color: var(--gerenalBackgroundColor);
    /* border-radius: 5px; */
    border: none;
    border-bottom: 1px solid #000;
    padding: 2px 2px 2px 15px;
    color: var(--primaryColor);
    font-weight: 600;
    font-size: 18px;
    /* :hover {
        background-color: #fff;
    } */

    :focus{
        border-color: var(--primaryColor);
    }
`;
export const ContainerSetas = styled.div`
    display: flex;
    flex-direction: column;

    cursor: pointer;
    margin-right: 3px;

    svg {
        :hover{
            background-color: #cecece;
        }
    }
`;

export const BtnSalvar = styled.button`
    padding: 10px 15px;
    color: #fff;
    background-color: var(--primaryColor);
    border:none;
    margin-right: 10px;
    border-radius: 5px;
    :hover{
        background-color: var(--primaryColorHover);
    }
`;
export const BtnCancelar = styled.button`
    padding: 10px 15px;
    color: #fff;
    background-color: var(--cancelColor);
    border:none;
    border-radius: 5px;
    :hover{
        background-color: var(--cancelColorHover);
    }
`;
